// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { operatorId } from './Operator';
import { calendarDate } from '../../calendar-date';
import { analyticLpsSampleTypeEnum } from './AnalyticLpsSampleTypeEnum';
import { testInstanceId } from './TestInstance';
import { z } from 'zod';
export const analyticLpsEndotoxinReportId = (z.number());
export const analyticLpsEndotoxinReport = z.object({
    id: analyticLpsEndotoxinReportId,
    sample_name: z.string(),
    analyst_id: operatorId,
    date_measured: calendarDate,
    sample_type: analyticLpsSampleTypeEnum,
    reading_a_eu_ml: z.string(),
    reading_b_eu_ml: z.string(),
    dilution_factor: z.string(),
    dry_weight_g_per_kg: z.string().nullable(),
    average_eu_ml: z.string(),
    stdev_eu_ml: z.string(),
    average_eu_per_g: z.string().nullable(),
    stdev_eu_per_g: z.string().nullable(),
    test_instance_id: testInstanceId.nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
});
export const analyticLpsEndotoxinReportInitializer = z.object({
    id: analyticLpsEndotoxinReportId.optional(),
    sample_name: z.string(),
    analyst_id: operatorId,
    date_measured: calendarDate,
    sample_type: analyticLpsSampleTypeEnum,
    reading_a_eu_ml: z.string(),
    reading_b_eu_ml: z.string(),
    dilution_factor: z.string().optional(),
    dry_weight_g_per_kg: z.string().optional().nullable(),
    average_eu_ml: z.string(),
    stdev_eu_ml: z.string(),
    average_eu_per_g: z.string().optional().nullable(),
    stdev_eu_per_g: z.string().optional().nullable(),
    test_instance_id: testInstanceId.optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
export const analyticLpsEndotoxinReportMutator = z.object({
    id: analyticLpsEndotoxinReportId.optional(),
    sample_name: z.string().optional(),
    analyst_id: operatorId.optional(),
    date_measured: calendarDate.optional(),
    sample_type: analyticLpsSampleTypeEnum.optional(),
    reading_a_eu_ml: z.string().optional(),
    reading_b_eu_ml: z.string().optional(),
    dilution_factor: z.string().optional(),
    dry_weight_g_per_kg: z.string().optional().nullable(),
    average_eu_ml: z.string().optional(),
    stdev_eu_ml: z.string().optional(),
    average_eu_per_g: z.string().optional().nullable(),
    stdev_eu_per_g: z.string().optional().nullable(),
    test_instance_id: testInstanceId.optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=AnalyticLpsEndotoxinReport.js.map